import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {reportDWH} from '../../EsimQrCodeBlockSlice';
import {openWhatsAppChatAsync} from '../../EsimQrCodeBlockAsyncThunk';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import {gtag4} from '../../../../../utilities/analytics/tracking';
import EpiContext from '@episerver/spa-core/Spa';
import infoIcon from './images/info-icon.svg';
import clockIcon from './images/clock-icon.svg';
import errorIcon from './images/error-icon.svg';

const ErrorPage = (props) => {
  useEffect(() => {
    switch (props.errorDescription) {
      case 'ERROR_OPEN_CHAT_ERROR':
        gtag4({event: 'EsimLine_IndicationWhatsappClosedError', error: props.errorDescription, action: 'IndicationWhatsappClosedError'});
        break;
      case 'NIUD_NOT_FINISH_ERROR':
        gtag4({event: 'EsimLine_IndicationNiudError', error: props.errorDescription, action: 'IndicationNiudError'});
        break;
      case 'CHECK_USER_ERROR_BUSINESS_USER':
        //gtag4({ event: 'EsimUpgrade_GeneralError', error: props.errorDescription, action: 'GeneralError' });
        break;
      default:
        gtag4({event: 'EsimUpgrade_GeneralError', error: props.errorDescription, action: 'GeneralError'});
        props.reportDWH({actionType: 'OTP Page Step2', status: 'Error', messageText: props.errorDescription});
        break;
    }
  }, []);

  let title = '';
  let subTitle = '';
  let icon = '';

  switch (props.errorDescription) {
    case 'ERROR_OPEN_CHAT_ERROR':
      title = 'מוקד ה-WhatsApp שלנו סגור כרגע';
      subTitle = 'ניתן לפנות למוקד השירות בטלפון';
      icon = clockIcon;
      break;
    case 'NIUD_NOT_FINISH_ERROR':
      title = `עדיין לא סיימת את תהליך הניוד שלך ל${window.Config.brand_Name_HE}`;
      subTitle = 'לפני שנוכל להפעיל את קו ה-eSIM שלך יש לבצע ניוד. פרטי הניוד נשלחו אליך במייל ובסמס';
      icon = infoIcon;
      break;
    case 'CHECK_USER_ERROR_BUSINESS_USER':
      title = 'רק רגע...';
      subTitle = 'נראה שיש לנו עסק עם מנוי עסקי';
      icon = errorIcon;
      break;
    default:
      title = 'מצטערים, משהו השתבש והתהליך לא הושלם';
      // subTitle = 'נציגנו יחזור אליך בהקדם האפשרי כדי לסיים את התהליך';
      icon = errorIcon;
      break;
  }

  return (
    <div className='error-page-wrapper' data-error={props.errorDescription}>
      <div className='error-page'>
        <div className='icon' style={{backgroundImage: icon?.bg()}}></div>
        <div className='title'>{title}</div>
        {/* <div className='phone'> קו {props.subscriberNo} </div> */}
        <div className='sub-title'>{subTitle}</div>

        <div className='contact-wrapper'>
          <div className='links-wrapper'>
            {props.errorDescription != 'ERROR_OPEN_CHAT_ERROR' && (
              <div className='contact-link whatsapp'>
                {' '}
                <a href='#' onClick={(e) => handleOpenWhatsApp(e)}>
                  {' '}
                  לנציג שירות ב-WhatsApp{' '}
                </a>{' '}
              </div>
            )}
            <div className='contact-link call-to-service'>
              {!isMobile ? (
                <span className='call-to-service-text'>
                  חייגו <span style={{direction: 'ltr'}}>&nbsp;{Config.technicalSupportPhone}&nbsp;</span> לנציג שירות
                </span>
              ) : (
                <a href={`tel:${Config.technicalSupportPhone}`}>
                  חייגו <span style={{direction: 'ltr'}}>&nbsp;{Config.technicalSupportPhone}&nbsp;</span> לנציג שירות
                </a>
              )}
            </div>
          </div>
        </div>

        <div className='button-wrapper'>
          <BtnSubmit
            isBusiness={false}
            text='לאזור אישי'
            onclick={handlePageContinue}
            formid='esim-block'
            isDisplayArrows={false}
            isDisplayWhatsAppIcon={false}
          />
        </div>
      </div>
    </div>
  );

  function handleOpenWhatsApp(e) {
    e.preventDefault();

    if (props.isWhatsAppActive) {
      props.openWhatsAppChatAsync();
    } else {
      const whatsAppLink = `https://wa.me/${Config.whatsAppSelfCare}?force_isolation=true&text=`;
      let win = window.open(whatsAppLink, '_blank');
      win.focus();
    }
  }

  function handlePageContinue() {
    //buildUrlAndOpenSameWindow(Config.lobbyUrl);
    //let content = props.context.loadContentByPath(Config.lobbyUrl);
    EpiContext.navigateTo(Config.lobbyUrl);
  }
};

const mapStateToProps = (state) => {
  return {
    isWhatsAppActive: state.esimQrCodeBlock.isWhatsAppActive,
    errorDescription: state.esimQrCodeBlock.errorDescription,
    subscriberNo: state.esimQrCodeBlock.loginDetails.subscriberNo,
  };
};

const mapDispatchToProps = {
  reportDWH,
  openWhatsAppChatAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
